import { IProcessingMergeJoinBlock } from './processingMergeJoinInnerBlock.models';

export const processingMergeJoinEmptyBlock = (
  block?: Partial<IProcessingMergeJoinBlock>
): IProcessingMergeJoinBlock => ({
  id: 0,
  singleActionBody: {},
  ...block
});
